export default __webpack_public_path__ + "static/anhaegnger@2x-4a65e94c8e769835f9f60f22e2a36c8f.jpg";